import React, { FC, memo, useCallback, useMemo } from 'react'

import { shortenAddress } from '../../../functions/address'
import { useIsMounted } from '../../../hooks'
import { SlideIn } from '../../Animation/SlideIn'
import CopyHelper from '../../Copy'
import { Dialog } from '../../Dialog'
import { Avatar } from '../Avatar'
import { Balance } from '../NetworkSwitch'
import { AccountSettingsOverlay } from './AccountSettingsOverlay'
import { SettingsModal } from './types'

export const AccountSettings: FC<SettingsModal> = memo(
  ({
    setSettings,
    isConnected,
    connectors,
    connect,
    disconnect,
    ENSName,
    chainId,
    account,
    connector,
    show = false,
    chain,
  }) => {
    const isMounted = useIsMounted()
    const handleClose = useCallback(() => {
      setSettings(false)
    }, [setSettings])

    return useMemo(() => {
      if (!isMounted) return <></>
      if (account && isMounted)
        return (
          <Dialog open={show} unmount={false} onClose={handleClose}>
            <Dialog.Content className="!max-w-md overflow-hidden h-[75vh] sm:h-[440px] pb-[116px]">
              <SlideIn>
                <Dialog.Header onClose={handleClose} title="Settings" />
                <div className="relative flex items-center justify-between w-full gap-1 pr-3 my-3 mb-5 ring-offset-2 ring-offset-slate-800 bg-slate-700 rounded-2xl focus-within:ring-2 text-primary ring-blue-500">
                  <div className="border border-gradient-r-gradientcustom-secondarybg border-transparent rounded-full z-50 w-[50px] h-[50px] overflow-hidden">
                    <div className="duration-500 scale-125 hover:scale-150">
                      <Avatar width={75} height={75} chainId={chainId} ENSName={ENSName} />
                    </div>
                  </div>
                  <div className="relative grid grid-flow-col gap-4 px-2 py-1 my-auto font-light duration-500 ease-in-out bg-gray-400 border rounded-lg w-fit text-xxs tracking-default">
                    <CopyHelper toCopy={ENSName ?? account}>
                      {ENSName ?? shortenAddress(account)}
                    </CopyHelper>
                    <div className="flex items-center gap-1 pr-2 font-normal">
                      <Balance account={account} chain={chain} isConnected={isConnected} />
                    </div>
                  </div>
                </div>
                <AccountSettingsOverlay
                  setSettings={setSettings}
                  isConnected={isConnected}
                  connectors={connectors}
                  connect={connect}
                  disconnect={disconnect}
                  connector={connector}
                />
              </SlideIn>
            </Dialog.Content>
          </Dialog>
        )
      return <></>
    }, [
      ENSName,
      account,
      chain,
      chainId,
      connect,
      connector,
      connectors,
      disconnect,
      handleClose,
      isConnected,
      isMounted,
      setSettings,
      show,
    ])
  }
)
